import * as Yup from 'yup';
import { SchemaOf } from 'yup';
import { IUnitFormProps } from '../types';

export const schemaUnit: SchemaOf<IUnitFormProps> = Yup.object({
  name: Yup.string().required(''),
  supervisors: Yup.array().optional(),
}).required();
